import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import Spinner from '../../components/Spinner';

import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import SegmentDetailsForm from '../../components/Segments/SegmentDetailsForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['segment']}`;

const SegmentsDetailPage = () => {
  const fetch = useFetch();
  const navigate = useNavigate();
  const location = useLocation();

  const [segment, setSegment] = useState();
  const [loadError, setLoadError] = useState();
  const { accountId, domainId, segmentId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/segments/${segmentId}`, {})
      .then(({ segment }) => setSegment(segment))
      .catch(setLoadError);
  }, [accountId, domainId, fetch, segmentId]);

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!segment) {
    return <Spinner />;
  }

  const navigateToParentPage = () => navigate(location.pathname.replace(`/segments/${segment.id}`, '/segments'));

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/segments` },
    { title: 'Details' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${segment.name} | Details`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <SegmentDetailsForm
              segment={segment}
              onSave={navigateToParentPage}
              onDelete={navigateToParentPage}
              onBack={() => navigate(-1)}
              onDuplicate={() =>
                navigate(
                  location.pathname.replace(`/segments/${segment.id}`, `/segments/new?fromSegment=${segment.id}`)
                )
              }
            />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default SegmentsDetailPage;
